import React from 'react';

export default function EmojiIcon(props) {
  return (
    <div className={props.className} alt={props.alt}>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8 6.4C11.8 7.10914 11.6603 7.81133 11.389 8.46649C11.1176 9.12165 10.7198 9.71694 10.2184 10.2184C9.71694 10.7198 9.12165 11.1176 8.46649 11.389C7.81133 11.6603 7.10914 11.8 6.4 11.8C5.69086 11.8 4.98867 11.6603 4.33351 11.389C3.67835 11.1176 3.08306 10.7198 2.58162 10.2184C2.08019 9.71694 1.68243 9.12165 1.41105 8.46649C1.13968 7.81133 1 7.10914 1 6.4C1 4.96783 1.56893 3.59432 2.58162 2.58162C3.59432 1.56893 4.96783 1 6.4 1C7.83217 1 9.20568 1.56893 10.2184 2.58162C11.2311 3.59432 11.8 4.96783 11.8 6.4Z"
          stroke="#C7D2DD"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 7.59995C4.27921 7.97278 4.64152 8.27537 5.05814 8.48368C5.47476 8.69199 5.93421 8.80028 6.4 8.79995C6.8658 8.80032 7.32527 8.69205 7.74189 8.48374C8.15852 8.27543 8.52082 7.97282 8.8 7.59995M4.6 5.20655V5.19995M8.2 5.20655V5.19995"
          stroke="#C7D2DD"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
